import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AppContext from '../../context/AppContext';

function Loader({ children }) {
  const { loaded } = useContext(AppContext);

  return <>{loaded ? children : <div>Carregando</div>}</>;
}

Loader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Loader;
